const parseFilenameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition) return null;

  // RFC 5987 (filename*=UTF-8''...)
  const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/^"|"$/g, ""));
    } catch {
      // ignore decode issues
    }
  }

  const basicMatch = contentDisposition.match(/filename\s*=\s*([^;]+)/i);
  if (basicMatch?.[1]) {
    return basicMatch[1].trim().replace(/^"|"$/g, "");
  }

  return null;
};

export const downloadBlob = ({ blob, filename, contentDisposition } = {}) => {
  if (!(blob instanceof Blob)) {
    throw new Error("downloadBlob expects a Blob.");
  }

  const resolvedFilename =
    parseFilenameFromContentDisposition(contentDisposition) ||
    filename ||
    "download.xlsx";

  const url = URL.createObjectURL(blob);
  try {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = resolvedFilename;
    anchor.style.display = "none";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  } finally {
    URL.revokeObjectURL(url);
  }
};

